<template>
  <div>
    <shop-head currentPageName="SHOP" ref="load_cart"></shop-head>
    <!-- 面包屑 -->
    <!-- 主要内容 -->
    <div class="content_wrapper">
      <div class="container">
        <br />
        <br />
        <!-- <breadcrumb pageName="产品库"></breadcrumb> -->
        <div class="search">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item :label="$t('配件分类一')">
              <el-select
                multiple
                v-model="search.categoryFirstSup"
                placeholder=""
                clearable
                filterable
                @change="categoryFirstSupChange"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="lang == 'zh' ? item.note : item.keyS"
                  :value="item.note"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('配件分类二')">
              <el-select
                multiple
                v-model="search.categorySecondSup"
                placeholder=""
                clearable
                filterable
              >
                <el-option
                  v-for="item in categorySecondList"
                  :key="item.id"
                  :label="lang == 'zh' ? item.note : item.keyS"
                  :value="item.note"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('配件品牌')">
              <el-select
                multiple
                v-model="search.manufacturerCname"
                placeholder=""
                clearable
                filterable
              >
                <el-option-group
                  v-for="(group, index) in brandList"
                  :key="index"
                  :label="index"
                >
                  <el-option
                    v-for="item in group"
                    :key="item.cname"
                    :label="item.cname"
                    :value="item.cname"
                  >
                    <span style="float: left">{{ item.cname }}</span>
                    <span style="float: right; width: 80px"
                      ><img
                        style="width: 100%; height: 34px"
                        :src="item.logo"
                        alt=""
                    /></span>
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('商品名称')">
              <el-input
                v-model="search.productName"
                placeholder=""
                size="normal"
                clearable
              ></el-input>
            </el-form-item>
            <el-button type="primary" @click="onSubmit">{{
              $t("查询")
            }}</el-button>
            <el-button @click="handleReset">{{ $t("重置") }}</el-button>
          </el-form>
        </div>
        <div class="table">
          <div class="changeS" @click="flexStatus = !flexStatus">
            <i v-if="flexStatus" class="el-icon-menu"></i>
            <i v-else class="el-icon-s-fold"></i>
            <!-- <p v-for="item in 6" :key="item + 99"></p> -->
          </div>
          <el-table :data="productList" style="width: 100%" v-if="flexStatus">
            <el-table-column :label="$t('商品图片')">
              <template slot-scope="scope">
                <img
                  style="width: 100%; height: 100px; cursor: pointer"
                  :src="
                    scope.row.picture.split(',')[0] != 0
                      ? scope.row.picture.split(',')[0]
                      : scope.row.companyLogo
                  "
                  alt=""
                  @click="gotoDetail(scope.row.id)"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('商品名称')">
              <template slot-scope="scope">
                <p>{{ lang == "zh" ? scope.row.cname : scope.row.ename }}</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('商品编码')">
              <template slot-scope="scope">
                {{ scope.row.partsNo }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('供应商')" width="230">
              <template slot-scope="scope">
                <p
                  style="cursor: pointer; color: #409eff"
                  @click="goDetail(scope.row.supplierId)"
                >
                  {{ scope.row.supplierName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('指导价')">
              <template slot-scope="scope"> ￥{{ scope.row.price }} </template>
            </el-table-column>
            <el-table-column :label="$t('操作')">
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <el-button size="mini" type="primary" @click="handle">{{
                    $t("立即询价")
                  }}</el-button>
                  <br />
                  <el-button
                    size="mini"
                    type="danger"
                    @click="addCart(scope.row.id)"
                    >{{ $t("加入购物车") }}</el-button
                  >
                  <br />
                  <el-button size="mini" type="success" @click="handle">{{
                    $t("联系客服")
                  }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="content" v-else>
            <div
              class="product"
              v-for="item in productList"
              :key="item.id"
              @click="gotoDetail(item.id)"
            >
              <img :src="item.picture.split(',')[0]" alt="" />
              <p>{{ item.partsNo }}</p>
              <p>{{ item.cname }}</p>
              <b>￥{{ item.price }}</b>
              <br />
              <br />
              <p>{{ item.supplierName }}</p>
            </div>
          </div>
          <el-pagination
            background
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleChangeSize"
            @current-change="handleSearch"
          />
        </div>
      </div>
    </div>
    <common-footer></common-footer>
    <el-dialog :visible.sync="showDetail" width="80%">
      <quick-view ref="quickView"></quick-view>
    </el-dialog>
    <!-- 侧边弹窗 -->
    <el-drawer :visible.sync="showFilterDialog" size="300px" direction="rtl">
      <div class="content_wrapper" style="padding: 0 20px">
        <!-- 价格过滤 -->
        <div class="sidebar_categories">
          <div class="categories_title first-child">
            <h5>Filter by price</h5>
          </div>
          <div class="price-filter">
            <el-slider v-model="priceRange" range :max="278"></el-slider>
          </div>
          <div class="price-slider-amount">
            <div>Price：</div>
            <div>$</div>
            <input v-model="priceRange[0]" type="text" class="price-input" />
            <div style="padding-right: 30px">-</div>
            <input v-model="priceRange[1]" type="text" class="price-input" />
            <button @click="searchByPrice(true)" class="filter-btn">
              Filter
            </button>
          </div>
        </div>
        <!-- 分类 -->
        <div class="sidebar_categories">
          <div class="categories_title">
            <h5>Product Categories</h5>
          </div>
          <!-- <ul class="sidebar_categories-box">
            <li @click="filterCategory(item.category, index, true)" v-for="(item, index) in categoryList"
              :key="item.name" :class="{ 'active': index === categoryIndex }">{{ item.name }}</li>
          </ul> -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import quickView from "../../components/shop/quickView";
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { cartSave } from "../../apis/company";
import { findCategorys, facturerList, productsList } from "../../apis/shop";
export default {
  components: {
    quickView,
    shopHead,
    commonFooter,
    breadcrumb,
  },
  data() {
    return {
      showFilterDialog: false,
      showDetail: false,
      priceRange: [0, 278],
      isList: false,
      alphabeticSort: 0, //0:默认 1:A-Z 2:Z-A
      priceSort: 0, //0:默认 1:价格升序 2:价格降序
      productList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageCount: 0,
      currentProductList: [],
      search: {
        categoryFirstSup: [],
        categorySecondSup: [],
        manufacturerCname: [],
        productName: "",
        currentPage: 1,
        pageSize: 10,
      },
      brandList: [],
      brand: "",
      categoryList: [],
      categorySecondList: [],
      category: "",
      flexStatus: true,
      lang: "",
    };
  },
  watch: {
    showDetail(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.quickView.resetData();
        });
      }
    },
  },
  mounted() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
    const productName = this.$route.query.title || "";
    if (this.$route.query.note) {
      this.search.categoryFirstSup.push(this.$route.query.fnote);
      this.search.categorySecondSup.push(this.$route.query.note);
    }
    this.search.productName = productName;
    this.getList();
    this.productsList();
    // this.pageCount = Math.ceil(this.productList.length / this.pageSize);
    // this.compareList = this.productList.slice(0, 4);
    // this.getCurrentProductList(this.productList);
  },
  methods: {
    async getList() {
      this.categoryList = (
        await findCategorys({ note: this.$route.query.fnote || "" })
      ).data;
      if (this.$route.query.fnote)
        this.categoryFirstSupChange([this.$route.query.fnote]);

      this.brandList = (await facturerList({ letter: "" })).data;
    },
    async productsList() {
      const { list, total } = (await productsList(this.search)).data.data;
      this.productList = list;
      this.total = total;
    },
    categoryFirstSupChange(e) {
      let categorySecondList = [];
      e.map((item) => {
        const arr = this.categoryList.find((v) => v.note == item).sysDictList;
        categorySecondList.push(...arr);
      });
      this.categorySecondList = categorySecondList;
    },
    onSubmit() {
      this.handleSearch();
    },
    handle() {
      this.$message(this.$i18n.t("该功能尚未开通，敬请期待!"));
    },
    toggelFilter() {
      this.showFilterDialog = !this.showFilterDialog;
    },
    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    goDetail(supplierId) {
      this.$router.push({
        path: "/companyDetail",
        query: { id: supplierId },
      });
    },
    handleReset() {
      Object.keys(this.search).forEach((key) => {
        if (key != "pageSize") {
          this.search[key] = "";
        }
      });
      this.search.categoryFirstSup = [];
      this.search.categorySecondSup = [];
      this.search.manufacturerCname = [];
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.search.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.productsList({ ...this.search, currentPage });
    },
    /** 跳转详情 */
    gotoDetail(id) {
      this.$router.push({
        path: "/shopDetail",
        query: {
          id: id,
        },
      });
    },
    /** 加入购物车 */
    async addCart(partsId) {
      try {
        await cartSave({ partsId });
        this.$message.success(this.$i18n.t("加入购物车成功!"));
        this.$refs.load_cart.$refs.head.getCarListData();
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message,
        });
      }
    },
    changeSort(type) {
      this.page = 1;
      let arr = JSON.parse(JSON.stringify(this.$productList.productList));
      let list = [];
      if (type === "price") {
        this.alphabeticSort = 0;
        this.priceSort++;
        if (this.priceSort > 2) {
          this.priceSort = 0;
        }
        if (this.priceSort === 1) {
          //价格升序
          this.productList = arr.sort((a, b) => {
            return a.price - b.price;
          });
        } else if (this.priceSort === 2) {
          //价格降序
          this.productList = arr.sort((a, b) => {
            return b.price - a.price;
          });
        } else {
          this.productList = arr;
        }
      } else {
        this.priceSort = 0;
        this.alphabeticSort++;
        if (this.alphabeticSort > 2) {
          this.alphabeticSort = 0;
        }
        //字母排序默认
        if (this.alphabeticSort === 0) {
          this.productList = arr;
        } else if (this.alphabeticSort === 1) {
          //字母Z-A
          this.productList = arr.sort((s1, s2) => {
            let x1 = s1.name.toUpperCase();
            let x2 = s2.name.toUpperCase();
            if (x1 < x2) {
              return -1;
            }
            if (x1 > x2) {
              return 1;
            }
            return 0;
          });
        } else {
          //字母Z-A
          this.productList = arr.sort((s1, s2) => {
            let x1 = s1.name.toUpperCase();
            let x2 = s2.name.toUpperCase();
            if (x1 < x2) {
              return 1;
            }
            if (x1 > x2) {
              return -1;
            }
            return 0;
          });
        }
      }
      this.getCurrentProductList(this.productList);
    },
    /** 价格筛选 */
    searchByPrice(isDialog = false) {
      this.page = 1;
      let arr = this.productList.filter((item) => {
        return (
          item.price >= this.priceRange[0] && item.price <= this.priceRange[1]
        );
      });
      this.pageCount = Math.ceil(arr.length / this.pageSize);
      this.getCurrentProductList(arr);
      if (isDialog) {
        this.showFilterDialog = false;
      }
    },
    /** 下一页 */
    nextPage() {
      if (this.page < this.pageCount) {
        this.page++;
        this.getCurrentProductList(this.productList);
      } else {
        this.$message.warning("The current page is the last page");
      }
    },
    /** 改变页码 */
    changePage(val) {
      this.page = val;
      this.getCurrentProductList(this.productList);
    },
    /** 截取当前页数据 */
    getCurrentProductList(arr) {
      let start = (this.page - 1) * this.pageSize;
      let end = this.page * this.pageSize;
      this.currentProductList = arr.slice(start, end);
    },
    /** 快速查看 */
    showQuickView(item) {
      this.showDetail = true;
      this.$nextTick(() => {
        this.$refs.quickView.productData = item;
      });
      console.log(this.$refs.quickView);
    },
    /** 切换产品显示模式 */
    toggleListMode(val) {
      this.isList = !this.isList;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;

  .search {
    ::v-deep .el-form--inline .el-form-item__content {
      width: 166px;
    }
  }

  .table {
    display: flex;
    flex-direction: column;
    text-align: end;
    padding: 20px 0px;
    position: relative;

    .changeS {
      top: 30px;
      right: 24px;
      position: absolute;
      width: 30px;
      height: 15px;
      display: flex;
      flex-wrap: wrap;
      // background-color: red;
      z-index: 9;
      cursor: pointer;
      font-size: 24px;
      color: #1684fc;
    }

    .content {
      width: 100%;
      padding-top: 40px;
      display: flex;
      align-content: center;
      flex-wrap: wrap;

      ul {
        display: flex;
        width: 100%;
        justify-content: space-around;
      }

      .product {
        box-sizing: border-box;
        width: 18.2%;
        text-align: center;
        padding: 20px 2px 0px 2px;
        margin: 10px;
        background-color: #fff;
        box-shadow: 0 0 10px #9999999f;
        img {
          width: 80%;
          height: 130px;
        }

        .el-input-number--mini {
          width: 85px;
        }
      }
    }
  }
}

.rating-box {
  width: 100%;
  color: #fed100;

  .iconfont {
    font-size: 12px;
  }

  .gray {
    color: #c0c0c0;
  }
}

.content_wrapper {
  padding: 0 0 60px;

  h5 {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 0;
    padding-bottom: 25px;
  }

  /** 价格过滤 */
  .sidebar-catagories_area {
    @media only screen and (max-width: 991px) {
      padding-top: 60px;
    }
  }

  .sidebar_categories {
    background: #fff;
    padding-top: 20px;

    .sidebar_categories-box {
      li {
        line-height: 1;
        font-size: 15px;
        padding-bottom: 20px;
        cursor: pointer;

        &:hover,
        &.active {
          color: #fed100;
        }
      }
    }

    .categories_title {
      border-bottom: 1px solid #ebebeb;
      position: relative;
      padding-top: 20px;
      margin-bottom: 20px;
      text-align: center;

      &.first-child {
        padding-top: 0;
      }
    }

    .price-filter {
      margin-top: 35px;

      ::v-deep .el-slider__bar {
        background: #fed100;
      }

      ::v-deep .el-slider__button {
        border-color: #fed100;
      }
    }

    .price-slider-amount {
      width: 100%;
      height: auto;
      line-height: 24px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .price-input {
        width: 40px;
        line-height: 24px;
        height: 24px;
        border: none;
        outline: none;
      }
    }

    .filter-btn {
      border: 1px solid #ebebeb;
      color: #999999;
      width: 85px;
      height: 40px;
      line-height: 39px;
      border-radius: 50px;
      background: none;

      &:hover {
        background-color: #fed100;
        border-color: #fed100;
        color: #ffffff;
      }
    }
  }

  /** 侧边 */
  .sidebar_categories {
    .categories_title {
      border-bottom: 1px solid #ebebeb;
      position: relative;
      padding-top: 20px;
      margin-bottom: 30px;
      text-align: center;
    }

    .sidebar_item {
      width: 100%;
      border: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      padding: 30px 10px;
      border-radius: 3px;
      margin-bottom: 30px;

      .product-img {
        width: 130px;
        flex: 0 0 130px;

        @media only screen and (min-width: 992px) {
          width: 60px;
          flex: 0 0 60px;
        }

        img {
          width: 100%;
        }
      }

      .product-content {
        flex: 1;
        padding-top: 25px;
        padding-left: 15px;

        .product-name {
          width: 100%;
          line-height: 13px;
          font-size: 13px;
          font-weight: 400;
          margin-bottom: 10px;
        }

        .price-box {
          font-size: 13px;

          .new-price {
            font-size: 16px;
            font-weight: 600;
            color: #e01212;
            margin-left: 5px;
          }
        }
      }
    }
  }

  /** banner */
  .shop-banner_area {
    width: 100%;
    padding-bottom: 25px;
    position: relative;

    .img-hover_effect {
      width: 100%;
      position: relative;
      display: block;
      overflow: hidden;

      img {
        width: 100%;
        transform: scale(1);
        transition: all 0.3s ease-in;
        display: block;
      }
    }

    &:hover {
      .img-hover_effect {
        img {
          transform: scale(1.06);
          transition: all 0.3s ease-in;
        }
      }
    }

    .banner-content {
      width: 90%;
      line-height: 1;
      font-size: 20px;
      color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;

      .btn-ps_center {
        width: 135px;
        height: 40px;
        line-height: 38px;
        font-size: 15px;
        color: #ffffff;
        font-weight: 600;
        border: 0;
        border-radius: 20px;
        background: #fed100;
        margin: 25px auto 0;
      }
    }
  }

  /** 产品列表 */
  .shop-toolbar {
    padding: 10px 0 25px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    .product-view-mode {
      .price-sort {
        width: auto;
        height: auto;
        font-size: 22px;
        color: #888;
        vertical-align: middle;
        position: relative;
        display: inline-block;

        &.active {
          color: #fed100;

          .iconfont {
            color: #fed100;
          }
        }

        .icon-jiagepaixu {
          font-size: 12px;
          color: #333;
          position: absolute;
          right: -15px;
          bottom: -5px;
        }
      }

      .iconfont {
        vertical-align: middle;
        color: #999;
        margin-right: 10px;
        cursor: pointer;

        &.active {
          color: #fed100;
        }
      }

      .icon-xiaosuolvetu {
        font-size: 24px;
      }

      .icon-viewList-fill {
        font-size: 30px;
      }
    }
  }

  .single-product {
    width: 100%;
    text-align: center;
    border: 1px solid #ebebeb;
    padding: 30px 10px;
    border-radius: 3px;
    margin-bottom: 30px;
    cursor: pointer;

    .product-img {
      overflow: visible;
      position: relative;
      text-align: center;
      position: relative;

      .primary-img {
        width: 100%;
      }

      .add-actions {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);

        li {
          width: 40px;
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          text-align: center;
          opacity: 0;
          background-color: #fed100;
          border-radius: 100%;
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px;
          transition: all 0.3s ease-in;

          &:nth-child(1) {
            transition-delay: 100ms;
          }

          &:nth-child(2) {
            transition-delay: 150ms;
          }

          &:nth-child(3) {
            transition-delay: 200ms;
          }
        }
      }
    }

    &:hover {
      border-color: #fed100;

      .add-actions {
        li {
          opacity: 1;
        }
      }
    }

    .product-content {
      padding-top: 25px;
    }
  }

  .price-box {
    padding-bottom: 15px;

    .new-price {
      color: #e01212;
      font-size: 22px;
      font-weight: 600;
    }

    .old-price {
      color: #c0c0c0;
      text-decoration: line-through;
      font-size: 16px;
      display: inline-block;
      margin-left: 5px;
    }
  }

  .product-name {
    font-size: 13px;
    line-height: 1;
    padding-bottom: 5px;
  }

  .list-product {
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #ebebeb;
    padding: 15px 25px;
    overflow: hidden;
    display: flex;
    margin-bottom: 30px;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;

    .list-img {
      width: 31%;
      flex: 0 0 31%;
      position: relative;

      img {
        width: 100%;
        cursor: pointer;
      }

      @media only screen and (max-width: 767px) {
        width: 100%;
        flex: 0 0 100%;
      }
    }

    .list-content {
      flex: 1;
      padding-left: 15px;

      .product-name {
        font-size: 16px;
        padding-bottom: 10px;
      }

      .list-short_desc {
        margin-bottom: 0;
        padding-bottom: 23px;
      }

      .add-actions {
        width: 100%;

        li {
          width: 40px;
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          text-align: center;
          background-color: #fed100;
          border-radius: 100%;
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px;
        }
      }
    }
  }

  .paginatoin-area {
    padding-top: 30px;
    text-align: center;

    .pagination-box {
      border: 2px solid #fed100;
      border-radius: 25px;
      padding: 10px 0;
      display: flex;
      justify-content: center;
      display: inline-block;

      li {
        padding: 0 15px;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #fed100;
        cursor: pointer;

        &:last-of-type {
          border: 0;
        }

        &.active {
          color: #fed100;
        }
      }
    }
  }
}

.ellipsis-more {
  line-height: 24px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /*超出2行就显示省略号，可以填3或者其它正整数*/
}
</style>